
import React, { useState, useEffect } from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

interface ChatbotAvatarProps {
  speaking: boolean;
}

const ChatbotAvatar: React.FC<ChatbotAvatarProps> = ({ speaking }) => {
  const [animationFrame, setAnimationFrame] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);
  
  // Simple animation effect when speaking
  useEffect(() => {
    if (!speaking) return;
    
    const interval = setInterval(() => {
      setAnimationFrame(prev => (prev + 1) % 3);
    }, 500);
    
    return () => clearInterval(interval);
  }, [speaking]);

  return (
    <div className="relative">
      <Avatar className="h-12 w-12 border-2 border-primary shadow-md">
        <AvatarImage 
          src="/lovable-uploads/a4693856-68b6-409f-8f78-84c4150495fd.png" 
          alt="Nurse Amy" 
          className="object-cover"
          onLoad={() => setImageLoaded(true)}
          onError={() => {
            console.error('Failed to load nurse avatar');
            setImageLoaded(false);
          }}
        />
        {!imageLoaded && (
          <AvatarFallback className="bg-primary text-primary-foreground">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </AvatarFallback>
        )}
      </Avatar>
      
      {speaking && (
        <div className="absolute -top-1 -right-1 flex space-x-1">
          {[0, 1, 2].map((i) => (
            <div 
              key={i} 
              className={`h-1.5 w-1.5 rounded-full bg-primary transition-all duration-200 ${
                i === animationFrame ? 'opacity-100 scale-100' : 'opacity-50 scale-75'
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ChatbotAvatar;
